// extracted by mini-css-extract-plugin
export default {"customCheckboxWrapper":"style_customCheckboxWrapper__TQEDw","customCheckbox":"style_customCheckbox__oJBrV","checkboxMark":"style_checkboxMark__Qo2K2","label":"style_label__h6RRk"};